export default __webpack_public_path__ + "static/media/CommunityGuidelinesTAGG.88164544.pdf";